import React from 'react'
import './footer.css'
import {RiFacebookCircleLine} from 'react-icons/ri'
import {BsInstagram} from 'react-icons/bs'
import { BsGithub } from 'react-icons/bs'
import {AiOutlineYoutube} from 'react-icons/ai'
import {AiOutlineLinkedin} from 'react-icons/ai'

const Footer = () => {
  return (
    <footer>
      <a href="#" className='footer__logo'>Ajay Singh</a>

      <ul className='permalinks'>
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        {/* <li><a href="#services">Services</a></li> */}
        <li><a href="#portfolio">Portfolio</a></li>
        {/* <li><a href="#testimonials">Testimonials</a></li> */}
        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className="footer__socials">
        <a href="https://www.linkedin.com/in/ajay-singh-66123b14b/" target='_blank'><AiOutlineLinkedin /></a>
        {/* <a href="https://www.facebook.com/Ajays9733/" target='_blank'><RiFacebookCircleLine /></a> */}
        <a href="https://www.instagram.com/aittitos51/" target='_blank'><BsInstagram /></a>
        <a href="https://github.com/Ajays9733" target='_blank'><BsGithub /></a>
        {/* <a href="https://www.youtube.com/@thebwls" target='_blank'><AiOutlineYoutube/></a> */}
      </div>

      <div className="footer__copyright">
        <small>&copy; Ajay Singh. All Rights Reserved</small>
      </div>
    </footer>
  )
}

export default Footer